import script from "./PositionsDetailPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./PositionsDetailPopup.vue?vue&type=script&setup=true&lang=ts"

import "./PositionsDetailPopup.vue?vue&type=style&index=0&id=232e8e68&lang=scss"

const __exports__ = script;

export default __exports__